import { jsx as _jsx } from "react/jsx-runtime";
import { List } from "@coveord/plasma-mantine";
import classes from "./DeletePromptList.module.css";
export var DeletePromptList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(List, {
        size: "sm",
        pr: "lg",
        className: classes.itemLabel,
        children: children
    });
};

//# sourceMappingURL=DeletePromptList.js.map